<template>
  <div class="orderDiscount">
    <!-- MEMO 如果是YOKOSO 不能用優惠卷 -->
    <!-- v-if="this['order/order'].hotel.hotelSource !== 'yokoso'" -->
    <div v-if="premiumCoupon && checkSelectedCouponIsStackable" class="payment__discount-premium border-premium-dark text-premium-dark">
      <h4 class="font-semibold flex items-center">
        {{ premiumCoupon.name }}
        <premiumImage type="icon" class="ml-4" style="width: 20px; height: 20px" />
      </h4>
      <p class="text-grey-darkest mt-4">
        {{ $t('premium.discount.login[0]') }} {{ $t('premium.discount.login[1]', { currency: currencySign, value: convertPremiumDiscount })}}
      </p>
    </div>
    <div class="payment__discount">
      <div
        v-show="isPromoteEventShow"
        class="flex flex-col md:flex-row overflow-hidden"
        :class="{ 'border-b-1 border-grey-lighter': this['user/isLogin'] }">
        <div class="payment__coupon-content px-24 py-16 flex flex-col md:flex-row items-start w-full">
          <figure class="mr-24 flex-no-shrink">
            <img src="@/assets/images/owj-coupon-3000.png" alt="owljourney-coupon-7%" class="mb-8 md:mb-0 md:p-12">
          </figure>
          <div>
            <!-- <label class="bg-blue text-white rounded-full inline-block px-8 py-4 mb-8 text-sm">{{ $t('promoteCoupon.memberOnly') }}</label> -->
            <h2 class="font-medium md:mb-8 text-xl"><router-link :to="promoteEventUrl" target="_blank" class="no-underline hover:underline hover:text-blue text-grey-darkest">{{ $t('promoteCoupon.title') }}</router-link></h2>
            <div class="text-sm leading-sm font-mono">
              <template>
                <div>
                  <span class="font-bold mr-8 text-grey-darkest">{{ $t(`promoteCoupon.coupon[0].lead`) }}</span>
                  <span>{{ $t(`promoteCoupon.coupon[0].tail`) }}</span>
                  <span v-if="isLogin" class="copyCouponButton" @click="copyCouponCode('SALE100', $event)">{{ $t('copyCoupon') }}</span>
                </div>
                <div>
                  <span class="font-bold mr-8 text-grey-darkest">{{ $t(`promoteCoupon.coupon[1].lead`) }}</span>
                  <span>{{ $t(`promoteCoupon.coupon[1].tail`) }}</span>
                  <span v-if="isLogin" class="copyCouponButton" @click="copyCouponCode('SALE300', $event)">{{ $t('copyCoupon') }}</span>
                </div>
                <div>
                  <span class="font-bold mr-8 text-grey-darkest">{{ $t(`promoteCoupon.coupon[2].lead`) }}</span>
                  <span>{{ $t(`promoteCoupon.coupon[2].tail`) }}</span>
                  <span v-if="isLogin" class="copyCouponButton" @click="copyCouponCode('SALE500', $event)">{{ $t('copyCoupon') }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isPremium" class="flex flex-col md:flex-row overflow-hidden justify-between border-grey-lighter border-b border-grey-lighter">
        <div class="payment__coupon-content px-24 py-16 flex flex-col md:flex-row items-start md:items-center flex-auto">
          <figure class="mt-24 md:mt-8 mb-8 md:mb-0 md:mr-24 flex-no-shrink" style="width: 120px;">
            <premiumImage type="logo"/>
          </figure>
          <div>
            <h2 class="text-base">{{ $t('premium.title') }}</h2>
            <div class="text-xl">
              <template v-if="!isLogin">
                <span class="font-bold">{{ $t('premium.discount.default[0]') }}</span>
                <span class="font-bold text-premium-dark">
                  {{ $t('premium.discount.default[1]', {currency: currencySign, value: convertPremiumDiscount }) }}
                </span>
              </template>
              <template v-else>
                <span class="font-bold">{{ $t('premium.discount.login[0]') }}</span>
                <span class="font-bold text-premium-dark">
                  {{ $t('premium.discount.login[1]', { currency: currencySign, value: convertPremiumDiscount }) }}
                </span>
              </template>
            </div>
          </div>
        </div>
        <div v-if="isLogin" class="mt-4 md:mt-16 m-16 flex items-center">
          <button @click="clickUpgrade" class="whitespace-no-wrap rounded-sm text-premium-dark border border-premium-dark hover:bg-premium hover:text-white no-underline text-sm px-12 py-8">{{ $t('upgrade') }}</button>
        </div>
      </div>
      <div v-if="!isLogin" class="flex flex-col md:flex-row justify-between md:items-center p-16">
        <span class="font-bold mb-16 md:mb-0">{{ $t('promoteCoupon.couponRightAway') }}</span>
        <button class="btn btn-sm px-16 btn-solid btn-blue-light" @click="becomeMember">{{ $t('notLogin.becomeMember') }}</button>
      </div>
      <div v-else>
        <div class="payment__block">
          <div class="payment__block-head">
            <h4 class="payment__title">{{ $t('discount') }}</h4>
            <div v-if="isCheckingCoupon" class="mr-16">
              <span class="mr-8 text-orange">{{ $t('loading') }}...</span>
            </div>
            <div v-else class="payment__switcher">
              <label v-if="canUseDiscount" class="owl-switch__wrap">
                <input type="checkbox" v-model="isDiscount" @change="toggleDiscounts">
                <div class="owl-switch__item">
                  <div class="owl-switch__bg">
                    <div class="owl-switch__button"></div>
                  </div>
                </div>
              </label>
              <div v-else-if="responseMsg" class="text-red">{{ $t('couponMsg.' + `${isExternalHotelSource ? 'coupon_cant_use_for_the_hotel' : responseMsg}`) }}</div>
            </div>
          </div>
          <div v-if="!isCheckingCoupon && isDiscount && hadSelectedCoupon" class="mt-16">
            <div class="flex flex-wrap flex-col-reverse md:flex-row items-baseline md:items-center justify-between">
              <div class="coupon-text-block">
                <div class="text-lg font-bold mb-4 flex items-center" :class="{'text-premium capitalize' : this['order/selectedCoupon'].code === 'PREMIUM_COUPON' }">
                  <span>{{ this['order/selectedCoupon'].name }}</span>
                  <premiumImage v-if="this['order/selectedCoupon'].code === 'PREMIUM_COUPON'" class="ml-4" type="icon"/>
                  <!-- <i v-if="this['order/selectedCoupon'].code === 'PREMIUM_COUPON'" class="ml-4 owl-rank-star bg-premium text-white rounded-full text-xs flex items-center justify-center" style="width: 16px; height: 16px;"></i> -->
                </div>
                <div class="text-grey-darker text-base font-medium mt-8">
                  <span v-if="this['order/selectedCoupon'].code === 'PREMIUM_COUPON'" class="text-grey-darker">
                    {{ $t('premium.discount.login[0]') }} {{ $t('premium.discount.login[1]', { currency: selectedCurrency, value: convertPremiumDiscount })}}
                  </span>
                  <span v-else-if="this['order/selectedCoupon'].code && this['order/selectedCoupon'].code !== 'travel_ticket_1000'">{{ $t('couponCode') }}: {{ this['order/selectedCoupon'].code }}</span>
                </div>
              </div>
              <div class="flex w-full md:w-auto mb-16 md:mb-0 mt-16 md:mt-0 items-center coupon-btn-block font-medium">
                <div v-if="this['order/selectedCoupon'].code === 'travel_ticket_1000'" class="text-2xl border-r border-grey mr-16 pr-16">
                  <span>NT$ {{ this['order/selectedCoupon'].maxDiscount | toCurrency }}</span>
                </div>
                <div v-else-if="this['order/selectedCoupon'].code !== 'PREMIUM_COUPON'" class="text-2xl border-r border-grey mr-16 pr-16">
                  <span v-if="this['order/selectedCoupon'].discountUnit === 'price'">
                    <span v-if="isCurrencyConvert">{{ $t('priceAbout') }} </span>
                    <span>{{ currencySign }} {{ Number(this['order/selectedCoupon'].discountValue) | currencyConvert({inputCurrency: this['order/selectedCoupon'].currency}) }}</span>
                  </span>
                  <span v-if="this['order/selectedCoupon'].discountUnit === 'percent'">
                    <span>{{ Number(this['order/selectedCoupon'].discountValue) | toPercentage }}%</span>
                  </span>
                </div>
                <button class="change-coupon-btn md:btn md:btn-text text-blue-light font-bold"
                  @click="editCoupon">
                  {{ $t('change') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import numeral from 'numeral'

import SimpleVueValidator from 'simple-vue-validator'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import PaymentDiscounts from '@/views/Order/components/modals/PaymentDiscounts'
import PremiumAddon from '@/views/Order/components/modals/PremiumAddon'
import clipboard from '@/utils/clipboard'
import orderMixin from '@/mixins/order'

const Validator = SimpleVueValidator.Validator
const { mapFields } = createHelpers({
  getterType: 'order/getField',
  mutationType: 'order/updateField'
})

export default {
  name: 'OrderDiscount',
  mixins: [
    orderMixin
  ],
  metaInfo () {
    return {
      title: '訂單折價'
    }
  },
  props: {
    showApplePayButton: {
      type: Boolean,
      default: false
    },
    premiumCoupon: {
      type: Object,
      default: null
    },
    promoCouponCode: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      openModaling: false,
      isCheckingCoupon: true,
      canUseDiscount: false,
      responseMsg: null,
      // Promote Event
      eventId: process.env.VUE_APP_PROMOTE_EVENT_ID,
      isPromoteEventShow: false
    }
  },
  filters: {
    toPercentage: function (val) {
      return 100 - val * 100
    }
  },
  validators: {
    'isDiscount': function (val) {
      return Validator.value(val).required()
    }
  },
  computed: {
    ...mapFields({
      isDiscount: 'payment.isDiscount'
    }),
    ...mapGetters({
      'user/coupons': 'user/coupons',
      'user/currencySign': 'user/currencySign',
      'order/selectedCoupon': 'order/selectedCoupon',
      'order/premiumCoupon': 'order/premiumCoupon',
      'order/promoCouponCode': 'order/promoCouponCode',
      'order/order': 'order/order',
      'user/isLogin': 'user/isLogin',
      externalHotelSource: 'hotels/externalHotelSource',
      isLogin: 'user/isLogin',
      isPremium: 'user/isPremium',
      isMobile: 'isMobile',
      selectedCurrency: 'user/selectedCurrency',
      'order/isUsingTaiwanTravel': 'order/isUsingTaiwanTravel'
    }),
    isUsingTaiwanTravel: function () {
      return this['order/isUsingTaiwanTravel']
    },
    promoteEventUrl: function () {
      return {
        name: 'Event',
        params: {
          eventId: this.eventId
        }
      }
    },
    hadSelectedCoupon: function () {
      return !_.isEmpty(this['order/selectedCoupon'])
    },
    convertPremiumDiscount: function () {
      return this.$options.filters.currencyConvert(this['order/order'].premiumDiscount, { inputCurrency: this['order/order'].currency })
    },
    discountValue: function () {
      if (this['order/selectedCoupon'].discountUnit === 'percent') {
        return this['order/selectedCoupon'].discountValue * 100
      } else {
        return this['order/selectedCoupon'].discountValue
      }
    },
    checkSelectedCouponIsStackable: function () {
      return !this.hadSelectedCoupon || this['order/selectedCoupon'].isStackable
    },
    isExternalHotelSource: function () {
      return this.externalHotelSource.includes(this['order/order'].source)
    },
    currencySign: function () {
      return this['user/currencySign']
    },
    isCurrencyConvert: function () {
      return this['order/order'].currency !== this.selectedCurrency
    },
    hotelCurrency: function () {
      return this['order/order'].currency
    }
  },
  methods: {
    ...mapActions([
      'order/setCouponToUpdate',
      'order/onSaveDiscount',
      'user/fetchProfile',
      'user/goLogin',
      'events/fetchEvent'
    ]),
    ...mapMutations([
      'order/SET_TAIWAN_TRAVEL',
      'order/RESET_TAIWAN_TRAVEL_CODE_LIST'
    ]),
    toggleDiscounts: function () {
      // 開優惠
      if (this.isDiscount) {
        // GTM GA4
        this.openModaling = true
        window.dataLayer.push({
          event: 'order_coupon_switch_on',
        })
        this.openModalDiscounts()
      } else {
        window.dataLayer.push({
          event: 'order_coupon_switch_off',
        })
        this['order/onSaveDiscount']({})
        this['order/SET_TAIWAN_TRAVEL'](false)
        this['order/RESET_TAIWAN_TRAVEL_CODE_LIST']()
      }
    },
    editCoupon: function () {
      window.dataLayer.push({
        event: 'order_coupon_change',
      })

      this.openModalDiscounts()
    },
    openModalDiscounts: function () {
      this.$modal.show(PaymentDiscounts, {
        onModalCancel: () => {
          if (!this.hadSelectedCoupon) {
            this.isDiscount = false
          }
        }
      },
      {
        adaptive: true,
        name: 'PaymentDiscounts',
        clickToClose: false,
        height: 'auto',
        width: '95%',
        maxWidth: 800,
        scrollable: true
      },
      {
        'before-close': () => {
          this.openModaling = false
        }
      })
    },
    clickUpgrade: function () {
      // GTM GA4
      window.dataLayer.push({
        event: 'order_coupon_upgrade_premium',
      })
      this['user/fetchProfile']()
        .then(response => {
          const { isPremium } = response.data

          if (isPremium) {
            window.location.reload()
          } else {
            this.openPremiumModal()
          }
        })
        .catch(() => {
          this.openPremiumModal()
        })
    },
    openPremiumModal: function () {
      const savedPrice = numeral(this.$options.filters.currencyConvert(this['order/order'].premiumDiscount, { inputCurrency: this['order/order'].currency, outputCurrency: 'TWD' })).value()

      this.$modal.show(PremiumAddon, {
        savedPrice
      }, {
        adaptive: true,
        name: 'PremiumAddon',
        clickToClose: false,
        height: 'auto',
        maxHeight: 550,
        width: this.isMobile ? '95%' : '600px'
      })
    },
    copyCouponCode: function (code, $event) {
      clipboard(code, $event, {
        success: `${this.$t('couponHadBeenCopy')} ${code}`
      })
    },
    becomeMember: function () {
      // GTM GA4
      window.dataLayer.push({
        event: 'order_coupon_register',
      })
      this['user/goLogin']()
    },
    checkingCoupon: function () {
      this.isCheckingCoupon = true
      this['order/setCouponToUpdate']().then(res => {
        this.canUseDiscount = true
        this.responseMsg = null
        if (res.data.coupon) {
          this.isDiscount = true
          this['order/onSaveDiscount'](res.data.coupon)
        }
      }).catch(err => {
        this.canUseDiscount = err.status !== 70108
        this.responseMsg = err.msg
      }).finally(() => {
        this.isCheckingCoupon = false
      })
    },
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
        if (this.isCurrencyConvert) {
          return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency })
        } else {
          return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency }))
        }
      }
    },
  },
  created () {
    if (this.eventId) {
      this['events/fetchEvent'](this.eventId).then(res => {
        if (res && (res.alias === this.eventId || res.id === this.eventId)) {
          this.isPromoteEventShow = true
        }
      })
    }
  },
  mounted () { // 如果是前一步是建單的話，isDiscount會是true
    if (this.promoCouponCode) {
      if (this.isDiscount) {
        this.checkingCoupon()
      } else {
        this.isDiscount = true
      }
    } else {
      if (this.isDiscount) {
        this.isDiscount = false
      }
      this.isCheckingCoupon = false
      this.canUseDiscount = true
    }
  },
  watch: {
    // promoCouponCode: {
    //   handler: function (val, oldVal) {
    //     console.log('promoCouponCode', oldVal, val)
    //     if (val) {
    //       console.log('promoCouponCode trigger')
    //       this.isDiscount = true
    //     }
    //   },
    //   deep: true
    // },
    isDiscount: {
      handler: function (val, oldVal) {
        if (this.openModaling) return false
        if (val && typeof oldVal === 'undefined' && !this.hadSelectedCoupon) {
          this.isDiscount = false
        }

        this.checkingCoupon()

        if (!!oldVal && !val) {
          console.debug('isDiscount off')
        }
      }
    },
    isUsingTaiwanTravel: {
      handler: function (val, oldVal) {
        if (val && this.isLogin && !this.isPremium) this.isDiscount = true
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
  .payment__discount
    @apply border border-grey-lighter rounded
    @apply mb-24
    border-radius: 20px

  .payment__discount-premium
    @apply border-2 rounded p-16 mb-24
    border-radius: 20px
  .payment__coupon-content
    figure
      width: 80px
      @screen md
        width: 100px
      img
        @apply w-full

  .payment__coupon-copy
    @apply flex-no-shrink flex flex-col justify-between relative
    &::before
      content: ''
      width: calc(100% - 32px)
      top: 0
      @apply border-t-1 border-grey-lighter mx-auto absolute
    @screen md
      @apply border-l-1 border-grey-lighter
      &::before
        @apply hidden
    &__btns
      @apply w-full mt-16
      button
        @apply w-full
      @screen md
        @apply w-auto mt-0
        button
          @apply w-auto

  .payment__block
    @apply p-16
    @screen sm
      @apply p-24
    & + &
      @apply border-t-1 border-grey-lighter
  .payment__block-head
    @apply flex justify-between items-center
  .payment__owl-points
    @apply text-2xl text-blue
  .payment-block-premium
    @apply p-16 mb-16
    @screen sm
      @apply p-24
    & + &
      @apply border-t-1 border-grey-lighter
  .payment__title
    @apply font-bold
  .payment__section
    @apply mt-24
  .payment__switcher
    @apply flex
    &-radio
      & + &
        @apply mt-16
        @screen sm
          @apply mt-0 ml-32

  .change-coupon-btn
    @apply py-0
    &:disabled
      @apply opacity-25 cursor-not-allowed

  .coupon-text-block
    order: 2
    @screen md
      order: 1

  .coupon-btn-block
    order: 1
    @screen md
      order: 2

  .errorMsg
    @apply text-xs text-red ml-4 mt-8
  .copyCouponButton
    @apply inline-block text-sm cursor-pointer text-blue my-4 pl-16
    &:active
      @apply text-orange
</style>
